import axios from 'axios'
import {store} from './index'
import {
  logoutAndRedirect
} from './store/actions/auth'
import {
  serviceNotAvailableModal
} from './utils/misc'
import moment from 'moment'
import jwt_decode from 'jwt-decode'

export default () => {
  const config = {
    baseURL: process.env.REACT_APP_API_URL
  }
  const instance = axios.create(config)
  instance.interceptors.response.use(function (response) {
    return response
  }, function (err) {
    // check if token is expired
    const {
      token,
      loginTimestamp
    } = store.getState().auth

    try {
      const decodedToken = jwt_decode(token)
      const now = moment()
      const expireTimeInSeconds = decodedToken.exp - decodedToken.iat
      const expiresAt = loginTimestamp.clone().add(expireTimeInSeconds, 's')
      if (now.isSameOrAfter(expiresAt)) {
        store.dispatch(logoutAndRedirect(decodedToken.type))
      }
    } catch (e) {
      console.error(e);
    }

    if (err.response) {
      switch (err.response.status) {
        case 423:
          serviceNotAvailableModal(err.response.data.message)
          break
        default:
          break
      }
    }
    return Promise.reject(err)
  })
  return instance
}
